import { Utilities } from '../../class/utilities';

export interface BuildWhatsAppLinkOptions {
  countryCode?: string;
  message?: string;
}

export function buildWhatsAppLink(phoneNumber: string, options: BuildWhatsAppLinkOptions = {}): string {
  const sanitizedPhoneNumber = Utilities.removeMask(phoneNumber ?? '');
  const countryCode = Utilities.removeMask(options.countryCode ?? '55');

  if (!sanitizedPhoneNumber) {
    throw new Error('phoneNumber é obrigatório para gerar o link do WhatsApp');
  }

  const fullPhoneNumber = `${countryCode}${sanitizedPhoneNumber}`;
  const encodedMessage = encodeURIComponent(options.message ?? '');

  return encodedMessage
    ? `https://wa.me/${fullPhoneNumber}?text=${encodedMessage}`
    : `https://wa.me/${fullPhoneNumber}`;
}
